module.exports = __webpack_public_path__ + "media/stylesheets/opensansi600-fa1d52f425ae43fa4849e41458379227.woff";